<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Specialization</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="special.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="special.desc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" :class="classPadding">
            <v-select
              :items="classificationItems"
              :class="classPadding"
              item-text="text"
              item-value="value"
              v-model="classification"
              label="Classification"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            :class="classPadding"
            v-if="classification == 'SUB'"
          >
            <v-text-field
              label="Major Specialization"
              v-model="special.subSpecDesc"
              :class="classPadding"
              clearable
              @click:clear="clearSpec"
              readonly
            >
              <template slot="append">
                <v-icon @click.stop="searchSpec">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <!-- <list :key="componentKey">
        <template slot="actions" slot-scope="{item}">
          <v-btn @click.stop="edit(item)" text icon>
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click.stop="deleteItem(item)" text icon>
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>-->
      <pagination :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </pagination>
      <!-- <router-view /> -->

      <v-dialog v-model="editDialog" width="900" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editSpecial.code"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Description"
                  :class="classPadding"
                  v-model="editSpecial.desc"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" :class="classPadding">
                <v-select
                  :items="classificationItems"
                  :class="classPadding"
                  item-text="text"
                  item-value="value"
                  v-model="classification"
                  label="Classification"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                :class="classPadding"
                v-if="classification == 'SUB'"
              >
                <v-text-field
                  label="Major Specialization"
                  v-model="editSpecial.subSpecDesc"
                  :class="classPadding"
                  clearable
                  @click:clear="clearSpec"
                  readonly
                >
                  <template slot="append">
                    <v-icon @click.stop="searchSpec">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
            </v-row>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="specDialog" width="700">
      <v-card>
        <v-card-title>
          <span class="headline">Specialization</span>
        </v-card-title>
        <v-card-text>
          <!-- <grade-list>
            <template slot="actions" slot-scope="{item}">
              <v-btn @click.stop="selectGrade(item)" text outlined>Select</v-btn>
            </template>
          </grade-list>-->
          <list :classification="'MAJOR'" v-if="specDialog">
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="selectSpec(item)" text outlined>Select</v-btn>
            </template>
          </list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="specDialog = false" text
            >CLose</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import List from "./List";
import Pagination from "./Pagination";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/specialization";
export default {
  metaInfo: {
    title: "Specialization",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List,
    Pagination
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    special: {},
    componentKey: 0,
    editSpecial: {},
    editDialog: false,
    specDialog: false,
    classificationItems: [
      {
        value: "MAJOR",
        text: "MAJOR"
      },
      {
        value: "SUB",
        text: "SUB"
      }
    ],
    classification: "MAJOR"
  }),
  methods: {
    save() {
      this.isSaving = true;
      this.special.classification = this.classification;
      this.$axios
        .post(`${API_ENDPOINT}`, this.special)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editSpecial = rel;
      this.editSpecial.code = rel.subSpecCode;
      this.editSpecial.desc = rel.subSpecDesc;
      this.editSpecial.specCode = rel.specCode;
      this.editSpecial.subSpecDesc = rel.specDesc;
      this.editSpecial.classification = rel.classification;
      this.classification = rel.classification;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.subSpecCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.special = {};
      this.forceRerender();
      this.editDialog = false;
      this.classification = "MAJOR";
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;
      this.editSpecial.classification = this.classification;
      this.$axios
        .put(`${API_ENDPOINT}`, this.editSpecial)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    searchSpec() {
      this.specDialog = true;
    },
    selectSpec(item) {
      if (!this.editDialog) {
        this.special.specCode = item.subSpecCode;
        this.special.subSpecDesc = item.subSpecDesc;
      } else {
        this.editSpecial.specCode = item.subSpecCode;
        this.editSpecial.subSpecDesc = item.subSpecDesc;
      }
      this.specDialog = false;
    },
    clearSpec() {
      if (!this.editDialog) {
        this.special.specCode = null;
        this.special.subSpecDesc = null;
      } else {
        this.editSpecial.specCode = null;
        this.editSpecial.subSpecDesc = null;
      }
    }
  },
  watch: {
    classification(val) {
      if (this.editDialog) {
        this.editSpecial.classification = val;
      } else {
        this.special.classification = val;
      }
    }
  },
  created() {
    this.getUserAccessRights("SubSpec");
  }
};
</script>